<template>
  <div class="sedform-container pa-4">
    <!-- Якщо форма успішно відправлена -->
    <div class="sed-form-sended py-5" v-if="formSended">
      <div class="font-weight-bold">{{$t('sedForm.confirmation')}}</div>
      <div class="mt-3">
        {{$t('formComponent.thankyForRequest')}}
      </div>
      <div class="text-center mt-4">
        <v-btn
          tile
          color="#549EC7"
          class="sed-form-sended-agree elevation-0 text-center"
          :to="{ name: 'page', params: { urlKey: 'home' } }"
        >
          {{$t('formComponent.agree')}}
        </v-btn>
      </div>
    </div>

    <!-- Якщо форма ще не відправлена -->
    <v-form
      v-else
      class="pa-4"
      style="width: 600px"
      v-model="formValidation"
      ref="form"
      @submit.prevent="submit"
    >
      <div class="d-flex">
        <span class="font-weight-bold mb-4">{{$t('requestDraftAgreement.requestDraftAgreement')}}</span>
        <v-spacer />
        <span class="text--disabled">{{$t('sedForm.allFieldsRequired')}}</span>
      </div>

      <div class="feedback-form">
        <!-- Вибір типу запиту -->
        <div class="feedback-form-block">
          <div class="feedback-form-inputs">
            <label>
              {{$t('requestDraftAgreement.agreementType')}}
              <span class="require">*</span>
            </label>
            <v-select
              :items="agreementTypes"
              item-text="name"
              item-value="value"
              dense
              :rules="required"
              outlined
              v-model="formModel.agreementTypeName"
            />
          </div>
        </div>

        <!-- Назва компанії -->
        <div class="feedback-form-block">
          <label>
            {{$t('requestDraftAgreement.companyName')}}
            <span class="require">*</span>
          </label>
          <div class="feedback-form-inputs">
            <v-text-field
              outlined
              dense
              :rules="required"
              v-model="formModel.companyName"
            />
          </div>
        </div>

        <!-- ЄДРПОУ -->
        <div class="feedback-form-block">
          <label>
            {{$t('sedForm.USREOU')}} <span class="require">*</span>
          </label>
          <div class="feedback-form-inputs">
            <v-text-field
              outlined
              dense
              :rules="edrpouRuled"
              v-model="formModel.edrpouCode"
            />
          </div>
        </div>

        <!-- Реквізити установи -->
        <div class="feedback-form-block">
          <label>
            {{$t('requestDraftAgreement.institutionDetails')}}
            <span class="require">*</span>
          </label>
          <div class="feedback-form-inputs">
            <v-text-field
              outlined
              dense
              :rules="required"
              v-model="formModel.institutionDetails"
            />
          </div>
        </div>

        <!-- Номер телефону -->
        <div class="feedback-form-block">
          <label>
            {{$t('requestDraftAgreement.ContactPhoneNumberOfResponsiblePerson')}}
            <span class="require">*</span>
          </label>
          <div class="feedback-form-inputs">
            <v-text-field
              outlined
              dense
              :rules="phoneRulse"
              v-model="formModel.phoneNumber"
            />
          </div>
        </div>

        <!-- Email -->
        <div class="feedback-form-block">
          <label>
            {{$t('trainingOfAskodForm.EmailAddress')}} <span class="require">*</span>
          </label>
          <div class="feedback-form-inputs">
            <v-text-field
              outlined
              dense
              :rules="emailRules"
              v-model="formModel.email"
            />
          </div>
        </div>
      </div>

      <!-- Компонент завантаження файлів -->
      <VueFileAgent
        helpText="Додати файл"
        :multiple="true"
        ref="fileAgent"
        theme="list"
        @beforedelete="onBeforeDelete"
        :maxSize="'5MB'"
        :deletable="true"
        :errorText="{
          type: 'Please select images, videos, pdf or zip files',
          size: 'Файл повинен бути менше ніж 5МБ'
        }"
        accept=".doc, .pdf, .docx, .xls., .xlsx"
        v-model="files"
      />

      <!-- Captcha (Зверніть увагу, що ми змінили @verify на onCaptchaVerify замість submit) -->
      <app-captcha
        ref="recaptcha"
        :isBudgeHidden="false"
        @verify="onCaptchaVerify"
      />

      <div class="d-flex align-center justify-space-around">
        <v-btn
          :loading="loading"
          tile
          class="submit-form-button"
          type="submit"
          elevation="0"
          color="#549EC7"
        >
          {{$t('formComponent.send')}}
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<script>
import serviceDataAccess from '../../../services/service.data-access'
import { required, email, phone, edrpou } from '@/utils/validation-rules'
import AppCaptcha from '../../_shared/AppCaptcha.vue'
import { keys } from 'lodash'

export default {
  name: 'RequestDraftAgreementForm',
  components: { AppCaptcha },
  data() {
    return {
      // Ініціалізація форми
      formModel: {
        agreementTypeName: '',
        companyName: '',
        edrpouCode: '',
        institutionDetails: '',
        phoneNumber: '',
        email: ''
      },
      files: [],
      formValidation: false,
      loading: false,
      formSended: false,
      agreementTypes: []
    }
  },
  created() {
    // Заповнюємо items у created()
    this.agreementTypes = [
      {
        name: this.$t('requestDraftAgreement.technicalSupport'),
        value: 'Технічна підтримка АСКОД'
      },
      {
        name: this.$t('requestDraftAgreement.licenceDelivery'),
        value: 'Постачання ліцензій АСКОД'
      },
      {
        name: this.$t('requestDraftAgreement.studying'),
        value: 'Навчання'
      },
      {
        name: this.$t('requestDraftAgreement.other'),
        value: 'Інші'
      }
    ]
  },
  methods: {
    /**
     * Викликається при натисканні на кнопку "Надіслати" (type="submit")
     * або при події submit форми.
     * 1) Валідовуємо поля.
     * 2) Якщо валідні — викликаємо reCaptcha.
     */
    async submit() {
      // Перевіряємо поля форми
      const isValid = await this.$refs.form.validate()

      if (isValid) {
        // Якщо все добре — показуємо вікно реКапчі
        this.$refs.recaptcha.execute()
      }
    },

    /**
     * Викликається автоматично компонентом <app-captcha @verify="onCaptchaVerify">
     * Користувач пройшов капчу — робимо реальне надсилання даних на бекенд
     */
    async onCaptchaVerify(token) {
      try {
        this.loading = true
        // Записуємо token у форму
        this.formModel.googleReCaptchaResponse = token

        // Створюємо FormData
        const formData = new FormData()
        if (this.files.length > 0) {
          this.files.forEach((file) => {
            formData.append('files', new File([file.file], file.name()))
          })
        }

        // Копіюємо всі поля з formModel
        const formKeys = keys(this.formModel)
        formKeys.forEach((key) => {
          formData.append(key, this.formModel[key])
        })

        // Відправляємо запит на бекенд
        await serviceDataAccess.sendRequestDraftAgreementForm(formData)
        this.$uiService.success('Форма відправлена успішно')

        this.formSended = true
      } catch (e) {
        this.$uiService.error('Помилка відправки форми', e)
      } finally {
        this.loading = false
      }
    },

    resetForm() {
      this.formModel = {
        agreementTypeName: '',
        companyName: '',
        edrpouCode: '',
        institutionDetails: '',
        phoneNumber: '',
        email: ''
      }
      this.files = []
      this.formSended = false
      this.formValidation = false
    },
    onBeforeDelete() {
      // Якщо потрібна додаткова логіка при видаленні файлів
    }
  },
  computed: {
    // Для обов'язкових полів
    required() {
      return [required]
    },
    // Для телефону: обов'язкове + валідація телефону
    phoneRulse() {
      return [required, phone]
    },
    // Для email: обов'язкове + валідація email
    emailRules() {
      return [required, email]
    },
    // Для ЄДРПОУ: обов'язкове + валідація
    edrpouRuled() {
      return [required, edrpou]
    }
  }
}
</script>

<style lang="scss" scoped>
.sedform-container {
  display: flex;
  justify-content: center;
  font-size: 1.7rem;

  form {
    max-width: 800px;
    background: #fff;
  }

  .sed-form-sended-agree {
    color: white;
    text-transform: none;
    font-size: 1.6rem;
  }

  .v-input {
    margin-top: 0.2rem;
  }

  .feedback-form-block-title {
    font-weight: bold;
  }

  .require {
    color: red;
  }
}

.header {
  h1 {
    font-size: 3.8rem;
  }
}
</style>
